module.exports = __webpack_public_path__ + "img/police.aeb7705e.jpg";